
<template>
    <div class="home-page">
        <b-container>
          <b-row>
            <b-col id="logo-rosteria">
              <img class="m-4" src="@/assets/logo-iso27.png">
            </b-col>
          </b-row>
          <b-row align-v="center">
            <b-col md="4">
              <div class="form-group">
                <label for="nboTeams">Number of Teams</label>
                <input type="number" id="nboTeams" class="form-control" v-model.number="store.nboTeams">
              </div>
            </b-col>
            <b-col md="4">
              <div class="form-group">
                <label for="nboDays">Number of Days</label>
                <input type="number" id="nboDays" class="form-control" v-model.number="store.nboDays">
              </div>
            </b-col>
            <b-col md="4">
              <b-button @click="start" block variant="primary">Start Game</b-button>
            </b-col>
          </b-row>
        </b-container>
    </div>
</template>

<script>

export default {
  name: 'home',
  computed: {
      store() {
          return this.$root.$data.store;
      }
  },
  methods: {
    start () {
      this.$parent.initStore();
      this.$router.push({name:'day',params:{day:1}})
    }
  }
}
</script>

<style scoped>
#logo-rosteria {
  text-align: center;
}
#logo-rosteria img {
    width: 80%;
}
h2 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

</style>